package com.exura.features.legacyplans.api.dto

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("IssueViaReceiverIdRequest")
data class IssueViaReceiverIdRequest(
    @JsName("detailedPlanId")
    val detailedPlanId: String,
    @JsName("receiverId")
    val receiverId: String
)


@Serializable
@JsName("HelloRequest")
data class HelloRequest(
    @JsName("name")
    val name: String,
)
